var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApifizLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Logo-2",
    "data-name": "Logo",
    className: "cls-1",
    d: "M123,41.94C196.23,4.76,284.72-10.23,365.42,7.31,314-3,241.14,63.47,185.17,83.43,95.07,115.55,22.28,93.1,123,41.94ZM263.94,179.16C301.66,154.34,448.47,29.63,486.77,76.62,385.58-56.83,290.26,73.4,184,111.31,70.54,151.76,31.17,117.75,55.19,92.52-95.87,237.69,93,291.64,263.94,179.16Zm18.69,25.46c-77.57,51-195.34,90-249.2,44.53,58.75,54.55,143.62,49.49,214.2,70,42.09-.84,71.74-20.54,110.81-50.35,89.44-68.22,132.45-37.34,119.18-11.12,23-35.19,40.94-76.1,32.06-128.9C492.34,25.65,324,177.42,282.63,204.62ZM367.71,291c-30.39,23.18-55.07,40.25-87.79,40.92,15.58,8.23,30.59,19.61,46.15,36.06,40.19,42.47,53.83,74.27,114,71.86C379.35,380,419.74,337,460.32,282.22,470.65,261.83,437.24,238,367.71,291Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApifizLogo);
export default __webpack_public_path__ + "static/media/apifizLogo.0801191b6b78ad9c4bbb4ca751812787.svg";
export { ForwardRef as ReactComponent };